import MultipleObstacle from '@presentation/assets/obstacles/multiple-obstacle.png'
import ShortLightTower from '@presentation/assets/obstacles/short-light-tower.png'
import ShortLightTowerActive from '@presentation/assets/obstacles/short-light-tower-active.png'
import ShortTower from '@presentation/assets/obstacles/short-tower.png'
import ShortTowerActive from '@presentation/assets/obstacles/short-tower-active.png'
import TallLightTower from '@presentation/assets/obstacles/tall-light-tower.png'
import TallLightTowerActive from '@presentation/assets/obstacles/tall-light-tower-active.png'
import TallTower from '@presentation/assets/obstacles/tall-tower.png'
import TallTowerActive from '@presentation/assets/obstacles/tall-tower-active.png'

export const obstacleIcons = {
  'obstacle-high': TallTower,
  'obstacle-high-lighted': TallLightTower,
  'obstacle-high-lighted-selected': TallLightTowerActive,
  'obstacle-high-selected': TallTowerActive,
  'obstacle-low': ShortTower,
  'obstacle-low-lighted': ShortLightTower,
  'obstacle-low-lighted-selected': ShortLightTowerActive,
  'obstacle-low-selected': ShortTowerActive,
  'obstacle-cluster': MultipleObstacle
} as const

export type ObstacleIconId = keyof typeof obstacleIcons
